// use this where you can't use the useTranslation hook

import translations from "./locales/en/translation.json";

export const t = (arg) => translations[arg];
